import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Rect } from '@antv/g';
import { deepMix, upperFirst } from '@antv/util';
import { group, groups } from 'd3-array';
import { format } from 'd3-format';
import { mapObject } from '../utils/array';
import { ChartEvent } from '../utils/event';
import { appendTransform, compose, copyAttributes, defined, error, maybeSubObject, subObject, useMemo } from '../utils/helper';
import { select, Selection } from '../utils/selection';
import { groupComponents, inferComponent, normalizeComponents, renderComponent } from './component';
import { AREA_CLASS_NAME, COMPONENT_CLASS_NAME, ELEMENT_CLASS_NAME, LABEL_CLASS_NAME, LABEL_LAYER_CLASS_NAME, MAIN_LAYER_CLASS_NAME, PLOT_CLASS_NAME, VIEW_CLASS_NAME } from './constant';
import { coordinate2Transform, createCoordinate } from './coordinate';
import { computeLayout, computeRoughPlotSize, placeComponents, processAxisZ } from './layout';
import { documentOf, useLibrary } from './library';
import { initializeMark } from './mark';
import { applyScale, assignScale, collectScales, inferScale, syncFacetsScales, useRelationScale } from './scale';
import { applyDataTransform } from './transform';
export function plot(options, selection, library, context) {
  var _a, _b;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _this = this;
    var _useLibrary, _useLibrary2, useComposition, _useLibrary3, _useLibrary4, useInteraction, marks, staticMarks, typeOf, isMark, isStandardView, isStaticMark, transform, views, viewNode, nodeState, discovered, nodeGenerators, node, state, _ref, _ref2, view, children, transformedNodes, states, i, nodeT, _state, n, N, enterContainer, updateContainer, transitions, viewInstanceof, enterViewInstances, _iterator2, _step2, target, _options, nameInteraction, _iterator5, _step5, typeOption, _typeOption, type, option, interaction, destroy, updateViewInstances, _iterator3, _step3, _target, _options2, container, _nameInteraction, _iterator6, _step6, _typeOption2, _typeOption3, _type, _option, prevInteraction, _interaction, _destroy, width, height, keyframes, _loop, _i, _nodeGenerators, finished;
    return _regeneratorRuntime().wrap(function _callee3$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _useLibrary = useLibrary('composition', library), _useLibrary2 = _slicedToArray(_useLibrary, 1), useComposition = _useLibrary2[0];
          _useLibrary3 = useLibrary('interaction', library), _useLibrary4 = _slicedToArray(_useLibrary3, 1), useInteraction = _useLibrary4[0]; // Some helper functions.
          marks = new Set(Object.keys(library).map(function (d) {
            var _a;
            return (_a = /mark\.(.*)/.exec(d)) === null || _a === void 0 ? void 0 : _a[1];
          }).filter(defined));
          staticMarks = new Set(Object.keys(library).map(function (d) {
            var _a;
            return (_a = /component\.(.*)/.exec(d)) === null || _a === void 0 ? void 0 : _a[1];
          }).filter(defined));
          typeOf = function typeOf(node) {
            var type = node.type;
            if (typeof type === 'function') {
              // @ts-ignore
              var _type$props = type.props,
                props = _type$props === void 0 ? {} : _type$props;
              var _props$composite = props.composite,
                composite = _props$composite === void 0 ? true : _props$composite;
              if (composite) return 'mark';
            }
            if (typeof type !== 'string') return type;
            if (marks.has(type) || staticMarks.has(type)) return 'mark';
            return type;
          };
          isMark = function isMark(node) {
            return typeOf(node) === 'mark';
          };
          isStandardView = function isStandardView(node) {
            return typeOf(node) === 'standardView';
          };
          isStaticMark = function isStaticMark(node) {
            var type = node.type;
            if (typeof type !== 'string') return false;
            if (staticMarks.has(type)) return true;
            return false;
          };
          transform = function transform(node) {
            if (isStandardView(node)) return [node];
            var type = typeOf(node);
            var composition = useComposition({
              type: type,
              static: isStaticMark(node)
            });
            return composition(node);
          }; // Some temporary variables help parse the view tree.
          views = [];
          viewNode = new Map();
          nodeState = new Map();
          discovered = [options];
          nodeGenerators = [];
        case 14:
          if (!discovered.length) {
            _context4.next = 53;
            break;
          }
          node = discovered.shift();
          if (!isStandardView(node)) {
            _context4.next = 41;
            break;
          }
          // Initialize view to get data to be visualized. If the marks
          // of the view have already been initialized (facet view),
          // initialize the view based on the initialized mark states,
          // otherwise initialize it from beginning.
          state = nodeState.get(node);
          if (!state) {
            _context4.next = 22;
            break;
          }
          _context4.t0 = initializeState(state, node, library);
          _context4.next = 25;
          break;
        case 22:
          _context4.next = 24;
          return initializeView(node, library);
        case 24:
          _context4.t0 = _context4.sent;
        case 25:
          _ref = _context4.t0;
          _ref2 = _slicedToArray(_ref, 2);
          view = _ref2[0];
          children = _ref2[1];
          viewNode.set(view, node);
          views.push(view);
          // Transform children, they will be transformed into
          // standardView if they are mark or view node.
          transformedNodes = children.flatMap(transform).map(function (d) {
            return coordinate2Transform(d, library);
          });
          discovered.push.apply(discovered, _toConsumableArray(transformedNodes));
          // Only StandardView can be treated as facet and it
          // should sync position scales among facets normally.
          if (!transformedNodes.every(isStandardView)) {
            _context4.next = 39;
            break;
          }
          _context4.next = 36;
          return Promise.all(transformedNodes.map(function (d) {
            return initializeMarks(d, library);
          }));
        case 36:
          states = _context4.sent;
          // Note!!!
          // This will mutate scales for marks.
          syncFacetsScales(states);
          for (i = 0; i < transformedNodes.length; i++) {
            nodeT = transformedNodes[i];
            _state = states[i];
            nodeState.set(nodeT, _state);
          }
        case 39:
          _context4.next = 51;
          break;
        case 41:
          if (!isMark(node)) {
            _context4.next = 45;
            break;
          }
          _context4.t1 = node;
          _context4.next = 48;
          break;
        case 45:
          _context4.next = 47;
          return applyTransform(node, library);
        case 47:
          _context4.t1 = _context4.sent;
        case 48:
          n = _context4.t1;
          N = transform(n);
          if (Array.isArray(N)) discovered.push.apply(discovered, _toConsumableArray(N));else if (typeof N === 'function') nodeGenerators.push(N());
        case 51:
          _context4.next = 14;
          break;
        case 53:
          context.emitter.emit(ChartEvent.BEFORE_PAINT);
          // Plot chart.
          enterContainer = new Map();
          updateContainer = new Map();
          transitions = [];
          selection.selectAll(className(VIEW_CLASS_NAME)).data(views, function (d) {
            return d.key;
          }).join(function (enter) {
            return enter.append('g').attr('className', VIEW_CLASS_NAME).attr('id', function (view) {
              return view.key;
            }).call(applyTranslate).each(function (view, i, element) {
              plotView(view, select(element), transitions, library, context);
              enterContainer.set(view, element);
            });
          }, function (update) {
            return update.call(applyTranslate).each(function (view, i, element) {
              plotView(view, select(element), transitions, library, context);
              updateContainer.set(view, element);
            });
          }, function (exit) {
            return exit.each(function (d, i, element) {
              // Remove existed interactions.
              var interactions = element['nameInteraction'].values();
              var _iterator = _createForOfIteratorHelper(interactions),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var interaction = _step.value;
                  interaction.destroy();
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }).remove();
          });
          // Apply interactions.
          viewInstanceof = function viewInstanceof(viewContainer) {
            return Array.from(viewContainer.entries()).map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                view = _ref4[0],
                container = _ref4[1];
              // Index state by component or interaction name,
              // such as legend, scrollbar, brushFilter.
              // Each state transform options to another options.
              var store = new Map();
              var setState = function setState(key) {
                var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
                  return x;
                };
                return store.set(key, reducer);
              };
              var _update = createUpdateView(select(container), library, context);
              var options = viewNode.get(view);
              return {
                view: view,
                container: container,
                options: options,
                setState: setState,
                update: function update() {
                  return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                    var reducer, newOptions;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          // Apply all state functions to get new options.
                          reducer = compose(Array.from(store.values()));
                          newOptions = reducer(options);
                          _context.next = 4;
                          return _update(newOptions);
                        case 4:
                          return _context.abrupt("return", _context.sent);
                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                }
              };
            });
          }; // Interactions for enter views.
          enterViewInstances = viewInstanceof(enterContainer);
          _iterator2 = _createForOfIteratorHelper(enterViewInstances);
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              target = _step2.value;
              _options = target.options; // A Map index interaction by interaction name.
              nameInteraction = new Map();
              target.container['nameInteraction'] = nameInteraction;
              // Apply interactions.
              _iterator5 = _createForOfIteratorHelper(inferInteraction(_options));
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  typeOption = _step5.value;
                  _typeOption = _slicedToArray(typeOption, 2), type = _typeOption[0], option = _typeOption[1];
                  if (option) {
                    interaction = useInteraction(Object.assign({
                      type: type
                    }, option));
                    destroy = interaction(target, enterViewInstances, context.emitter);
                    nameInteraction.set(type, {
                      destroy: destroy
                    });
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }
            // Interactions for update views.
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          updateViewInstances = viewInstanceof(updateContainer);
          _iterator3 = _createForOfIteratorHelper(updateViewInstances);
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _target = _step3.value;
              _options2 = _target.options, container = _target.container;
              _nameInteraction = container['nameInteraction'];
              _iterator6 = _createForOfIteratorHelper(inferInteraction(_options2));
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  _typeOption2 = _step6.value;
                  _typeOption3 = _slicedToArray(_typeOption2, 2), _type = _typeOption3[0], _option = _typeOption3[1]; // Remove interaction for existed views.
                  prevInteraction = _nameInteraction.get(_type);
                  if (prevInteraction) (_a = prevInteraction.destroy) === null || _a === void 0 ? void 0 : _a.call(prevInteraction);
                  // Apply new interaction.
                  if (_option) {
                    _interaction = useInteraction(Object.assign({
                      type: _type
                    }, _option));
                    _destroy = _interaction(_target, updateViewInstances, context.emitter);
                    _nameInteraction.set(_type, {
                      destroy: _destroy
                    });
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }
            // Author animations.
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          width = options.width, height = options.height;
          keyframes = [];
          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
            var nodeGenerator, keyframe;
            return _regeneratorRuntime().wrap(function _loop$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  nodeGenerator = _nodeGenerators[_i];
                  // Delay the rendering of animation keyframe. Different animation
                  // created by different nodeGenerator will play in the same time.
                  // eslint-disable-next-line no-async-promise-executor
                  keyframe = new Promise(function (resolve) {
                    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                      var _iterator4, _step4, _node, sizedNode;
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            _iterator4 = _createForOfIteratorHelper(nodeGenerator);
                            _context2.prev = 1;
                            _iterator4.s();
                          case 3:
                            if ((_step4 = _iterator4.n()).done) {
                              _context2.next = 10;
                              break;
                            }
                            _node = _step4.value;
                            sizedNode = Object.assign({
                              width: width,
                              height: height
                            }, _node);
                            _context2.next = 8;
                            return plot(sizedNode, selection, library, context);
                          case 8:
                            _context2.next = 3;
                            break;
                          case 10:
                            _context2.next = 15;
                            break;
                          case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2["catch"](1);
                            _iterator4.e(_context2.t0);
                          case 15:
                            _context2.prev = 15;
                            _iterator4.f();
                            return _context2.finish(15);
                          case 18:
                            resolve();
                          case 19:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2, null, [[1, 12, 15, 18]]);
                    }));
                  });
                  keyframes.push(keyframe);
                case 3:
                case "end":
                  return _context3.stop();
              }
            }, _loop);
          });
          _i = 0, _nodeGenerators = nodeGenerators;
        case 69:
          if (!(_i < _nodeGenerators.length)) {
            _context4.next = 74;
            break;
          }
          return _context4.delegateYield(_loop(), "t2", 71);
        case 71:
          _i++;
          _context4.next = 69;
          break;
        case 74:
          context.views = views;
          // Clear and update animation.
          (_b = context.animations) === null || _b === void 0 ? void 0 : _b.forEach(function (animation) {
            return animation === null || animation === void 0 ? void 0 : animation.cancel();
          });
          context.animations = transitions;
          context.emitter.emit(ChartEvent.AFTER_PAINT);
          // Note!!!
          // The returned promise will never resolved if one of nodeGenerator
          // never stop to yield node, which may created by a keyframe composition
          // with iteration count set to infinite.
          finished = transitions.filter(defined).map(cancel).map(function (d) {
            return d.finished;
          });
          return _context4.abrupt("return", Promise.all([].concat(_toConsumableArray(finished), keyframes)));
        case 80:
        case "end":
          return _context4.stop();
      }
    }, _callee3);
  }));
}
function applyTranslate(selection) {
  selection.style('transform', function (d) {
    return "translate(".concat(d.layout.x, ", ").concat(d.layout.y, ")");
  });
}
function createUpdateView(selection, library, context) {
  var _this2 = this;
  return function (newOptions) {
    return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var transitions, _yield$initializeView, _yield$initializeView2, newView, newChildren, _iterator7, _step7, child;
      return _regeneratorRuntime().wrap(function _callee4$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            transitions = [];
            _context5.next = 3;
            return initializeView(newOptions, library);
          case 3:
            _yield$initializeView = _context5.sent;
            _yield$initializeView2 = _slicedToArray(_yield$initializeView, 2);
            newView = _yield$initializeView2[0];
            newChildren = _yield$initializeView2[1];
            plotView(newView, selection, transitions, library, context);
            updateTooltip(selection, newOptions, newView, library, context);
            _iterator7 = _createForOfIteratorHelper(newChildren);
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                child = _step7.value;
                plot(child, selection, library, context);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
            return _context5.abrupt("return", {
              options: newOptions,
              view: newView
            });
          case 12:
          case "end":
            return _context5.stop();
        }
      }, _callee4);
    }));
  };
}
function updateTooltip(selection, options, view, library, context) {
  var _a;
  var _useLibrary5 = useLibrary('interaction', library),
    _useLibrary6 = _slicedToArray(_useLibrary5, 1),
    useInteraction = _useLibrary6[0]; // Instances for tooltip.
  var container = selection.node();
  var nameInteraction = container['nameInteraction'];
  var tooltipOptions = inferInteraction(options).find(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      d = _ref6[0];
    return d === 'tooltip';
  });
  // Destroy older tooltip.
  var tooltip = nameInteraction.get('tooltip');
  if (!tooltip) return;
  (_a = tooltip.destroy) === null || _a === void 0 ? void 0 : _a.call(tooltip);
  if (!tooltipOptions[1]) return;
  // Apply new tooltip interaction.
  var applyTooltip = useInteraction(Object.assign({
    type: 'tooltip'
  }, tooltipOptions[1]));
  var target = {
    options: options,
    view: view,
    container: selection.node(),
    update: function update(options) {
      return Promise.resolve(options);
    }
  };
  applyTooltip(target, [], context.emitter);
}
function initializeView(options, library) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var flattenOptions, mergedOptions, transformedOptions, state;
    return _regeneratorRuntime().wrap(function _callee5$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return transformMarks(options, library);
        case 2:
          flattenOptions = _context6.sent;
          mergedOptions = bubbleOptions(flattenOptions); // @todo Remove this.
          // !!! NOTE: Mute original view options.
          // Update interaction and coordinate for this view.
          options.interaction = mergedOptions.interaction;
          options.coordinate = mergedOptions.coordinate;
          transformedOptions = coordinate2Transform(mergedOptions, library);
          _context6.next = 9;
          return initializeMarks(transformedOptions, library);
        case 9:
          state = _context6.sent;
          return _context6.abrupt("return", initializeState(state, transformedOptions, library));
        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee5);
  }));
}
function bubbleOptions(options) {
  var _options$coordinate = options.coordinate,
    viewCoordinate = _options$coordinate === void 0 ? {} : _options$coordinate,
    _options$interaction = options.interaction,
    viewInteraction = _options$interaction === void 0 ? {} : _options$interaction,
    _options$style = options.style,
    viewStyle = _options$style === void 0 ? {} : _options$style,
    marks = options.marks,
    rest = __rest(options, ["coordinate", "interaction", "style", "marks"]);
  var markCoordinates = marks.map(function (d) {
    return d.coordinate || {};
  });
  var markInteractions = marks.map(function (d) {
    return d.interaction || {};
  });
  var markViewStyles = marks.map(function (d) {
    return d.viewStyle || {};
  });
  var newCoordinate = [].concat(_toConsumableArray(markCoordinates), [viewCoordinate]).reduceRight(function (prev, cur) {
    return deepMix(prev, cur);
  }, {});
  var newInteraction = [viewInteraction].concat(_toConsumableArray(markInteractions)).reduce(function (prev, cur) {
    return deepMix(prev, cur);
  }, {});
  var newStyle = [].concat(_toConsumableArray(markViewStyles), [viewStyle]).reduce(function (prev, cur) {
    return deepMix(prev, cur);
  }, {});
  return Object.assign(Object.assign({}, rest), {
    marks: marks,
    coordinate: newCoordinate,
    interaction: newInteraction,
    style: newStyle
  });
}
function transformMarks(options, library) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var _useLibrary7, _useLibrary8, useMark, createMark, staticMarks, marks, flattenMarks, components, discovered, _computeRoughPlotSize, width, height, context, _loop2;
    return _regeneratorRuntime().wrap(function _callee6$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _useLibrary7 = useLibrary('mark', library), _useLibrary8 = _slicedToArray(_useLibrary7, 2), useMark = _useLibrary8[0], createMark = _useLibrary8[1];
          staticMarks = new Set(Object.keys(library).map(function (d) {
            var _a;
            return (_a = /component\.(.*)/.exec(d)) === null || _a === void 0 ? void 0 : _a[1];
          }).filter(defined));
          marks = options.marks;
          flattenMarks = [];
          components = [];
          discovered = _toConsumableArray(marks);
          _computeRoughPlotSize = computeRoughPlotSize(options), width = _computeRoughPlotSize.width, height = _computeRoughPlotSize.height;
          context = {
            options: options,
            width: width,
            height: height
          }; // Pre order traversal.
          _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
            var _discovered$splice, _discovered$splice2, node, mark, _mark$type, type, key, _createMark, _createMark$props, props, _props$composite2, composite, data, newMark, _marks, M;
            return _regeneratorRuntime().wrap(function _loop2$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  _discovered$splice = discovered.splice(0, 1), _discovered$splice2 = _slicedToArray(_discovered$splice, 1), node = _discovered$splice2[0]; // Apply data transform to get data.
                  _context7.next = 3;
                  return applyTransform(node, library);
                case 3:
                  mark = _context7.sent;
                  _mark$type = mark.type, type = _mark$type === void 0 ? error('G2Mark type is required.') : _mark$type, key = mark.key; // For components.
                  if (!staticMarks.has(type)) {
                    _context7.next = 9;
                    break;
                  }
                  components.push(mark);
                  _context7.next = 22;
                  break;
                case 9:
                  _createMark = createMark(type), _createMark$props = _createMark.props, props = _createMark$props === void 0 ? {} : _createMark$props;
                  _props$composite2 = props.composite, composite = _props$composite2 === void 0 ? true : _props$composite2;
                  if (composite) {
                    _context7.next = 15;
                    break;
                  }
                  flattenMarks.push(mark);
                  _context7.next = 22;
                  break;
                case 15:
                  // Unwrap data from { value: data } to data,
                  // then the composite mark can process the normalized data.
                  data = mark.data;
                  newMark = Object.assign(Object.assign({}, mark), {
                    data: data ? Array.isArray(data) ? data : data.value : data
                  }); // Convert composite mark to marks.
                  _context7.next = 19;
                  return useMark(newMark, context);
                case 19:
                  _marks = _context7.sent;
                  M = Array.isArray(_marks) ? _marks : [_marks];
                  discovered.unshift.apply(discovered, _toConsumableArray(M.map(function (d, i) {
                    return Object.assign(Object.assign({}, d), {
                      key: "".concat(key, "-").concat(i)
                    });
                  })));
                case 22:
                case "end":
                  return _context7.stop();
              }
            }, _loop2);
          });
        case 9:
          if (!discovered.length) {
            _context8.next = 13;
            break;
          }
          return _context8.delegateYield(_loop2(), "t0", 11);
        case 11:
          _context8.next = 9;
          break;
        case 13:
          return _context8.abrupt("return", Object.assign(Object.assign({}, options), {
            marks: flattenMarks,
            components: components
          }));
        case 14:
        case "end":
          return _context8.stop();
      }
    }, _callee6);
  }));
}
function initializeMarks(options, library) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _useLibrary9, _useLibrary10, useTheme, _useLibrary11, _useLibrary12, createMark, partialTheme, partialMarks, _options$coordinates, coordinates, theme, markState, _iterator8, _step8, markOptions, type, _createMark2, _createMark2$props, props, markAndState, _markAndState, initializedMark, state, scaleChannels, _iterator9, _step9, _loop3;
    return _regeneratorRuntime().wrap(function _callee7$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _useLibrary9 = useLibrary('theme', library), _useLibrary10 = _slicedToArray(_useLibrary9, 1), useTheme = _useLibrary10[0];
          _useLibrary11 = useLibrary('mark', library), _useLibrary12 = _slicedToArray(_useLibrary11, 2), createMark = _useLibrary12[1];
          partialTheme = options.theme, partialMarks = options.marks, _options$coordinates = options.coordinates, coordinates = _options$coordinates === void 0 ? [] : _options$coordinates;
          theme = useTheme(inferTheme(partialTheme));
          markState = new Map(); // Initialize channels for marks.
          _iterator8 = _createForOfIteratorHelper(partialMarks);
          _context10.prev = 6;
          _iterator8.s();
        case 8:
          if ((_step8 = _iterator8.n()).done) {
            _context10.next = 18;
            break;
          }
          markOptions = _step8.value;
          type = markOptions.type;
          _createMark2 = createMark(type), _createMark2$props = _createMark2.props, props = _createMark2$props === void 0 ? {} : _createMark2$props;
          _context10.next = 14;
          return initializeMark(markOptions, props, library);
        case 14:
          markAndState = _context10.sent;
          if (markAndState) {
            _markAndState = _slicedToArray(markAndState, 2), initializedMark = _markAndState[0], state = _markAndState[1];
            markState.set(initializedMark, state);
          }
        case 16:
          _context10.next = 8;
          break;
        case 18:
          _context10.next = 23;
          break;
        case 20:
          _context10.prev = 20;
          _context10.t0 = _context10["catch"](6);
          _iterator8.e(_context10.t0);
        case 23:
          _context10.prev = 23;
          _iterator8.f();
          return _context10.finish(23);
        case 26:
          // Group channels by scale key, each group has scale.
          scaleChannels = group(Array.from(markState.values()).flatMap(function (d) {
            return d.channels;
          }), function (_ref7) {
            var scaleKey = _ref7.scaleKey;
            return scaleKey;
          }); // Infer scale for each channel groups.
          _iterator9 = _createForOfIteratorHelper(scaleChannels.values());
          _context10.prev = 28;
          _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3() {
            var channels, scaleOptions, scaleKey, FV, fields, options, name, values, scale;
            return _regeneratorRuntime().wrap(function _loop3$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  channels = _step9.value;
                  // Merge scale options for these channels.
                  scaleOptions = channels.reduce(function (total, _ref8) {
                    var scale = _ref8.scale;
                    return deepMix(total, scale);
                  }, {});
                  scaleKey = channels[0].scaleKey; // Use the fields of the first channel as the title.
                  FV = channels[0].values;
                  fields = Array.from(new Set(FV.map(function (d) {
                    return d.field;
                  }).filter(defined)));
                  options = deepMix({
                    guide: {
                      title: fields.length === 0 ? undefined : fields
                    },
                    field: fields[0]
                  }, scaleOptions); // Use the name of the first channel as the scale name.
                  name = channels[0].name;
                  values = channels.flatMap(function (_ref9) {
                    var values = _ref9.values;
                    return values.map(function (d) {
                      return d.value;
                    });
                  });
                  scale = Object.assign(Object.assign({}, inferScale(name, values, options, coordinates, theme, library)), {
                    key: scaleKey
                  });
                  channels.forEach(function (channel) {
                    return channel.scale = scale;
                  });
                case 10:
                case "end":
                  return _context9.stop();
              }
            }, _loop3);
          });
          _iterator9.s();
        case 31:
          if ((_step9 = _iterator9.n()).done) {
            _context10.next = 35;
            break;
          }
          return _context10.delegateYield(_loop3(), "t1", 33);
        case 33:
          _context10.next = 31;
          break;
        case 35:
          _context10.next = 40;
          break;
        case 37:
          _context10.prev = 37;
          _context10.t2 = _context10["catch"](28);
          _iterator9.e(_context10.t2);
        case 40:
          _context10.prev = 40;
          _iterator9.f();
          return _context10.finish(40);
        case 43:
          return _context10.abrupt("return", markState);
        case 44:
        case "end":
          return _context10.stop();
      }
    }, _callee7, null, [[6, 20, 23, 26], [28, 37, 40, 43]]);
  }));
}
function initializeState(markState, options, library) {
  var _useLibrary13 = useLibrary('mark', library),
    _useLibrary14 = _slicedToArray(_useLibrary13, 1),
    useMark = _useLibrary14[0];
  var _useLibrary15 = useLibrary('theme', library),
    _useLibrary16 = _slicedToArray(_useLibrary15, 1),
    useTheme = _useLibrary16[0];
  var _useLibrary17 = useLibrary('labelTransform', library),
    _useLibrary18 = _slicedToArray(_useLibrary17, 1),
    useLabelTransform = _useLibrary18[0];
  var key = options.key,
    _options$frame = options.frame,
    frame = _options$frame === void 0 ? false : _options$frame,
    partialTheme = options.theme,
    clip = options.clip,
    _options$style2 = options.style,
    style = _options$style2 === void 0 ? {} : _options$style2,
    _options$labelTransfo = options.labelTransform,
    labelTransform = _options$labelTransfo === void 0 ? [] : _options$labelTransfo;
  var theme = useTheme(inferTheme(partialTheme));
  // Infer components and compute layout.
  var states = Array.from(markState.values());
  var scales = collectScales(states, options);
  var components = normalizeComponents(inferComponent(inferComponentScales(Array.from(scales), states, markState), options, library));
  var layout = computeLayout(components, options, theme, library);
  var coordinate = createCoordinate(layout, options, library);
  var framedStyle = frame ? deepMix({
    mainLineWidth: 1,
    mainStroke: '#000'
  }, style) : style;
  // Place components and mutate their bbox.
  placeComponents(groupComponents(components), coordinate, layout);
  // AxisZ need a copy of axisX and axisY to show grids in X-Z & Y-Z planes.
  processAxisZ(components);
  // Scale from marks and components.
  var scaleInstance = {};
  // Initialize scale from components.
  var _iterator10 = _createForOfIteratorHelper(components),
    _step10;
  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var component = _step10.value;
      var _component$scales = component.scales,
        scaleDescriptors = _component$scales === void 0 ? [] : _component$scales;
      var _scales = [];
      var _iterator12 = _createForOfIteratorHelper(scaleDescriptors),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var descriptor = _step12.value;
          var name = descriptor.name;
          var scale = useRelationScale(descriptor, library);
          _scales.push(scale);
          assignScale(scaleInstance, _defineProperty({}, name, scale));
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      component.scaleInstances = _scales;
    }
    // Calc data to be rendered for each mark.
    // @todo More readable APIs for Container which stays
    // the same style with JS standard and lodash APIs.
    // @todo More proper way to index scale for different marks.
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  var children = [];
  var _iterator11 = _createForOfIteratorHelper(markState.entries()),
    _step11;
  try {
    var _loop4 = function _loop4() {
      var _step11$value = _slicedToArray(_step11.value, 2),
        mark = _step11$value[0],
        state = _step11$value[1];
      var createChildren = mark.children,
        dataDomain = mark.dataDomain,
        modifier = mark.modifier,
        markKey = mark.key;
      var index = state.index,
        channels = state.channels,
        tooltip = state.tooltip;
      var scale = Object.fromEntries(channels.map(function (_ref10) {
        var name = _ref10.name,
          scale = _ref10.scale;
        return [name, scale];
      }));
      // Transform abstract value to visual value by scales.
      var markScaleInstance = mapObject(scale, function (options) {
        return useRelationScale(options, library);
      });
      assignScale(scaleInstance, markScaleInstance);
      var value = applyScale(channels, markScaleInstance);
      // Calc points and transformation for each data,
      // and then transform visual value to visual data.
      var calcPoints = useMark(mark);
      var _filterValid = filterValid(calcPoints(index, markScaleInstance, value, coordinate)),
        _filterValid2 = _slicedToArray(_filterValid, 3),
        I = _filterValid2[0],
        P = _filterValid2[1],
        S = _filterValid2[2];
      var count = dataDomain || I.length;
      var T = modifier ? modifier(P, count, layout) : [];
      var titleOf = function titleOf(i) {
        var _a, _b;
        return (_b = (_a = tooltip.title) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.value;
      };
      var itemsOf = function itemsOf(i) {
        return tooltip.items.map(function (V) {
          return V[i];
        });
      };
      var visualData = I.map(function (d, i) {
        var datum = Object.assign({
          points: P[i],
          transform: T[i],
          index: d,
          markKey: markKey,
          viewKey: key
        }, tooltip && {
          title: titleOf(d),
          items: itemsOf(d)
        });
        var _loop5 = function _loop5() {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
            k = _Object$entries$_i[0],
            V = _Object$entries$_i[1];
          datum[k] = V[d];
          if (S) datum["series".concat(upperFirst(k))] = S[i].map(function (i) {
            return V[i];
          });
        };
        for (var _i2 = 0, _Object$entries = Object.entries(value); _i2 < _Object$entries.length; _i2++) {
          _loop5();
        }
        if (S) datum['seriesIndex'] = S[i];
        if (S && tooltip) {
          datum['seriesItems'] = S[i].map(function (si) {
            return itemsOf(si);
          });
          datum['seriesTitle'] = S[i].map(function (si) {
            return titleOf(si);
          });
        }
        return datum;
      });
      state.data = visualData;
      state.index = I;
      // Create children options by children callback,
      // and then propagate data to each child.
      var markChildren = createChildren === null || createChildren === void 0 ? void 0 : createChildren(visualData, markScaleInstance, layout);
      children.push.apply(children, _toConsumableArray(markChildren || []));
    };
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      _loop4();
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }
  var view = {
    layout: layout,
    theme: theme,
    coordinate: coordinate,
    markState: markState,
    key: key,
    clip: clip,
    scale: scaleInstance,
    style: framedStyle,
    components: components,
    labelTransform: compose(labelTransform.map(useLabelTransform))
  };
  return [view, children];
}
function plotView(view, selection, transitions, library, context) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var components, theme, layout, markState, coordinate, key, style, clip, scale, x, y, width, height, rest, areaKeys, I, sizeKeys, areaStyles, areaSizes, styleArea, px, py, pw, ph, areaLayouts, animationExtent, componentAnimateOptions, _iterator13, _step13, _step13$value, C, componentsTransitions, T, _iterator14, _step14, _loop6;
    return _regeneratorRuntime().wrap(function _callee8$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          components = view.components, theme = view.theme, layout = view.layout, markState = view.markState, coordinate = view.coordinate, key = view.key, style = view.style, clip = view.clip, scale = view.scale; // Render background for the different areas.
          x = layout.x, y = layout.y, width = layout.width, height = layout.height, rest = __rest(layout, ["x", "y", "width", "height"]);
          areaKeys = ['view', 'plot', 'main', 'content'];
          I = areaKeys.map(function (_, i) {
            return i;
          });
          sizeKeys = ['a', 'margin', 'padding', 'inset'];
          areaStyles = areaKeys.map(function (d) {
            return maybeSubObject(Object.assign({}, theme.view, style), d);
          });
          areaSizes = sizeKeys.map(function (d) {
            return subObject(rest, d);
          });
          styleArea = function styleArea(selection) {
            return selection.style('x', function (i) {
              return areaLayouts[i].x;
            }).style('y', function (i) {
              return areaLayouts[i].y;
            }).style('width', function (i) {
              return areaLayouts[i].width;
            }).style('height', function (i) {
              return areaLayouts[i].height;
            }).each(function (i, d, element) {
              applyStyle(select(element), areaStyles[i]);
            });
          };
          px = 0;
          py = 0;
          pw = width;
          ph = height;
          areaLayouts = I.map(function (i) {
            var size = areaSizes[i];
            var _size$left = size.left,
              left = _size$left === void 0 ? 0 : _size$left,
              _size$top = size.top,
              top = _size$top === void 0 ? 0 : _size$top,
              _size$bottom = size.bottom,
              bottom = _size$bottom === void 0 ? 0 : _size$bottom,
              _size$right = size.right,
              right = _size$right === void 0 ? 0 : _size$right;
            px += left;
            py += top;
            pw -= left + right;
            ph -= top + bottom;
            return {
              x: px,
              y: py,
              width: pw,
              height: ph
            };
          });
          selection.selectAll(className(AREA_CLASS_NAME)).data(
          // Only render area with defined style.
          I.filter(function (i) {
            return defined(areaStyles[i]);
          }), function (i) {
            return areaKeys[i];
          }).join(function (enter) {
            return enter.append('rect').attr('className', AREA_CLASS_NAME).style('zIndex', -2).call(styleArea);
          }, function (update) {
            return update.call(styleArea);
          }, function (exit) {
            return exit.remove();
          });
          animationExtent = computeAnimationExtent(markState);
          componentAnimateOptions = animationExtent ? {
            duration: animationExtent[1]
          } : false; // Render components.
          // @todo renderComponent return ctor and options.
          // Key for each type of component.
          // Index them grouped by position.
          _iterator13 = _createForOfIteratorHelper(groups(components, function (d) {
            return "".concat(d.type, "-").concat(d.position);
          }));
          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              _step13$value = _slicedToArray(_step13.value, 2), C = _step13$value[1];
              C.forEach(function (d, i) {
                return d.index = i;
              });
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
          componentsTransitions = selection.selectAll(className(COMPONENT_CLASS_NAME)).data(components, function (d) {
            return "".concat(d.type, "-").concat(d.position, "-").concat(d.index);
          }).join(function (enter) {
            return enter.append('g').style('zIndex', function (_ref11) {
              var zIndex = _ref11.zIndex;
              return zIndex || -1;
            }).attr('className', COMPONENT_CLASS_NAME).append(function (options) {
              return renderComponent(deepMix({
                animate: componentAnimateOptions,
                scale: scale
              }, options), coordinate, theme, library, markState);
            });
          }, function (update) {
            return update.transition(function (options, i, element) {
              var _options$preserve = options.preserve,
                preserve = _options$preserve === void 0 ? false : _options$preserve;
              if (preserve) return;
              var newComponent = renderComponent(deepMix({
                animate: componentAnimateOptions,
                scale: scale
              }, options), coordinate, theme, library, markState);
              var attributes = newComponent.attributes;
              var _element$childNodes = _slicedToArray(element.childNodes, 1),
                node = _element$childNodes[0];
              return node.update(attributes);
            });
          }).transitions();
          transitions.push.apply(transitions, _toConsumableArray(componentsTransitions.flat().filter(defined)));
          // Main layer is for showing the main visual representation such as marks. There
          // may be multiple main layers for a view, each main layer correspond to one of marks.
          // @todo Test DOM structure.
          T = selection.selectAll(className(PLOT_CLASS_NAME)).data([layout], function () {
            return key;
          }).join(function (enter) {
            return enter
            // Make this layer interactive, such as click and mousemove events.
            .append('rect').style('zIndex', 0).style('fill', 'transparent').attr('className', PLOT_CLASS_NAME).call(updateBBox).call(updateLayers, Array.from(markState.keys())).call(applyClip, clip);
          }, function (update) {
            return update.call(updateLayers, Array.from(markState.keys())).call(function (selection) {
              return animationExtent ? animateBBox(selection, animationExtent) : updateBBox(selection);
            }).call(applyClip, clip);
          }).transitions();
          transitions.push.apply(transitions, _toConsumableArray(T.flat()));
          // Render marks with corresponding data.
          _iterator14 = _createForOfIteratorHelper(markState.entries());
          _context12.prev = 23;
          _loop6 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop6() {
            var _step14$value, mark, state, data, key, cls, type, viewNode, shapeFunction, enterFunction, updateFunction, exitFunction, facetElements, T;
            return _regeneratorRuntime().wrap(function _loop6$(_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  _step14$value = _slicedToArray(_step14.value, 2), mark = _step14$value[0], state = _step14$value[1];
                  data = state.data;
                  key = mark.key, cls = mark.class, type = mark.type;
                  viewNode = selection.select("#".concat(key));
                  shapeFunction = createMarkShapeFunction(mark, state, view, library, context);
                  enterFunction = createEnterFunction(mark, state, view, library);
                  updateFunction = createUpdateFunction(mark, state, view, library);
                  exitFunction = createExitFunction(mark, state, view, library);
                  facetElements = selectFacetElements(selection, viewNode, cls, 'element');
                  T = viewNode.selectAll(className(ELEMENT_CLASS_NAME)).selectFacetAll(facetElements).data(data, function (d) {
                    return d.key;
                  }, function (d) {
                    return d.groupKey;
                  }).join(function (enter) {
                    return enter.append(shapeFunction)
                    // Note!!! Only one className can be set.
                    // Using attribute as alternative for other classNames.
                    .attr('className', ELEMENT_CLASS_NAME).attr('markType', type).transition(function (data, i, element) {
                      return enterFunction(data, [element]);
                    });
                  }, function (update) {
                    return update.call(function (selection) {
                      var parent = selection.parent();
                      var origin = useMemo(function (node) {
                        var _node$getBounds$min = _slicedToArray(node.getBounds().min, 2),
                          x = _node$getBounds$min[0],
                          y = _node$getBounds$min[1];
                        return [x, y];
                      });
                      selection.transition(function (data, index, element) {
                        maybeFacetElement(element, parent, origin);
                        var node = shapeFunction(data, index);
                        var animation = updateFunction(data, [element], [node]);
                        if (animation !== null) return animation;
                        if (element.nodeName === node.nodeName) copyAttributes(element, node);else {
                          element.parentNode.replaceChild(node, element);
                          node.className = ELEMENT_CLASS_NAME;
                          // @ts-ignore
                          node.markType = type;
                        }
                        return animation;
                      }).attr('markType', type).attr('className', ELEMENT_CLASS_NAME);
                    });
                  }, function (exit) {
                    return exit.each(function (d, i, element) {
                      element.__removed__ = true;
                    }).transition(function (data, i, element) {
                      return exitFunction(data, [element]);
                    }).remove();
                  }, function (merge) {
                    return merge
                    // Append elements to be merged.
                    .append(shapeFunction).attr('className', ELEMENT_CLASS_NAME).attr('markType', type).transition(function (data, i, element) {
                      // Remove merged elements after animation finishing.
                      var fromElements = element.__fromElements__;
                      var transition = updateFunction(data, fromElements, [element]);
                      var exit = new Selection(fromElements, null, element.parentNode);
                      exit.transition(transition).remove();
                      return transition;
                    });
                  }, function (split) {
                    return split.transition(function (data, i, element) {
                      // Append splitted shapes.
                      var enter = new Selection([], element.__toData__, element.parentNode);
                      var toElements = enter.append(shapeFunction).attr('className', ELEMENT_CLASS_NAME).attr('markType', type).nodes();
                      return updateFunction(data, [element], toElements);
                    })
                    // Remove elements to be splitted after animation finishing.
                    .remove();
                  }).transitions();
                  transitions.push.apply(transitions, _toConsumableArray(T.flat()));
                case 11:
                case "end":
                  return _context11.stop();
              }
            }, _loop6);
          });
          _iterator14.s();
        case 26:
          if ((_step14 = _iterator14.n()).done) {
            _context12.next = 30;
            break;
          }
          return _context12.delegateYield(_loop6(), "t0", 28);
        case 28:
          _context12.next = 26;
          break;
        case 30:
          _context12.next = 35;
          break;
        case 32:
          _context12.prev = 32;
          _context12.t1 = _context12["catch"](23);
          _iterator14.e(_context12.t1);
        case 35:
          _context12.prev = 35;
          _iterator14.f();
          return _context12.finish(35);
        case 38:
          // Plot label for this view.
          plotLabel(view, selection, transitions, library, context);
        case 39:
        case "end":
          return _context12.stop();
      }
    }, _callee8, null, [[23, 32, 35, 38]]);
  }));
}
/**
 * Auto hide labels be specify label layout.
 */
function plotLabel(view, selection, transitions, library, context) {
  var _useLibrary19 = useLibrary('labelTransform', library),
    _useLibrary20 = _slicedToArray(_useLibrary19, 1),
    useLabelTransform = _useLibrary20[0];
  var markState = view.markState,
    labelTransform = view.labelTransform;
  var labelLayer = selection.select(className(LABEL_LAYER_CLASS_NAME)).node();
  // A Map index shapeFunction by label.
  var labelShapeFunction = new Map();
  // A Map index options by label.
  var labelDescriptor = new Map();
  // Get all labels for this view.
  var labels = Array.from(markState.entries()).flatMap(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      mark = _ref13[0],
      state = _ref13[1];
    var _mark$labels = mark.labels,
      labelOptions = _mark$labels === void 0 ? [] : _mark$labels,
      key = mark.key;
    var shapeFunction = createLabelShapeFunction(mark, state, view, library, context);
    var elements = selection.select("#".concat(key)).selectAll(className(ELEMENT_CLASS_NAME)).nodes()
    // Only select the valid element.
    .filter(function (n) {
      return !n.__removed__;
    });
    return labelOptions.flatMap(function (labelOption, i) {
      var _labelOption$transfor = labelOption.transform,
        transform = _labelOption$transfor === void 0 ? [] : _labelOption$transfor,
        options = __rest(labelOption, ["transform"]);
      return elements.flatMap(function (e) {
        var L = getLabels(options, i, e);
        L.forEach(function (l) {
          labelShapeFunction.set(l, shapeFunction);
          labelDescriptor.set(l, labelOption);
        });
        return L;
      });
    });
  });
  // Render all labels.
  var labelShapes = select(labelLayer).selectAll(className(LABEL_CLASS_NAME)).data(labels, function (d) {
    return d.key;
  }).join(function (enter) {
    return enter.append(function (d) {
      return labelShapeFunction.get(d)(d);
    }).attr('className', LABEL_CLASS_NAME);
  }, function (update) {
    return update.each(function (d, i, element) {
      // @todo Handle Label with different type.
      var shapeFunction = labelShapeFunction.get(d);
      var node = shapeFunction(d);
      copyAttributes(element, node);
    });
  }, function (exit) {
    return exit.remove();
  }).nodes();
  // Apply group-level transforms.
  var labelGroups = group(labelShapes, function (d) {
    return labelDescriptor.get(d.__data__);
  });
  var coordinate = view.coordinate;
  var _iterator15 = _createForOfIteratorHelper(labelGroups),
    _step15;
  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var _step15$value = _slicedToArray(_step15.value, 2),
        label = _step15$value[0],
        shapes = _step15$value[1];
      var _label$transform = label.transform,
        transform = _label$transform === void 0 ? [] : _label$transform;
      var transformFunction = compose(transform.map(useLabelTransform));
      transformFunction(shapes, coordinate);
    }
    // Apply view-level transform.
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }
  if (labelTransform) {
    labelTransform(labelShapes, coordinate);
  }
}
function getLabels(label, labelIndex, element) {
  var _element$__data__ = element.__data__,
    SI = _element$__data__.seriesIndex,
    seriesKey = _element$__data__.seriesKey,
    points = _element$__data__.points,
    key = _element$__data__.key,
    index = _element$__data__.index;
  var bounds = getLocalBounds(element);
  if (!SI) {
    return [Object.assign(Object.assign({}, label), {
      key: "".concat(key, "-").concat(labelIndex),
      bounds: bounds,
      index: index,
      points: points,
      dependentElement: element
    })];
  }
  var selector = normalizeLabelSelector(label);
  var F = SI.map(function (index, i) {
    return Object.assign(Object.assign({}, label), {
      key: "".concat(seriesKey[i], "-").concat(labelIndex),
      bounds: [points[i]],
      index: index,
      points: points,
      dependentElement: element
    });
  });
  return selector ? selector(F) : F;
}
function filterValid(_ref14) {
  var _ref15 = _slicedToArray(_ref14, 3),
    I = _ref15[0],
    P = _ref15[1],
    S = _ref15[2];
  if (S) return [I, P, S];
  var definedIndex = [];
  var definedPoints = [];
  for (var i = 0; i < I.length; i++) {
    var d = I[i];
    var p = P[i];
    if (p.every(function (_ref16) {
      var _ref17 = _slicedToArray(_ref16, 2),
        x = _ref17[0],
        y = _ref17[1];
      return defined(x) && defined(y);
    })) {
      definedIndex.push(d);
      definedPoints.push(p);
    }
  }
  return [definedIndex, definedPoints];
}
function normalizeLabelSelector(label) {
  var selector = label.selector;
  if (!selector) return null;
  if (typeof selector === 'function') return selector;
  if (selector === 'first') return function (I) {
    return [I[0]];
  };
  if (selector === 'last') return function (I) {
    return [I[I.length - 1]];
  };
  throw new Error("Unknown selector: ".concat(selector));
}
/**
 * Avoid getting error bounds caused by element animations.
 * @todo Remove this temporary handle method, if runtime supports
 * correct process: drawElement, do label layout and then do
 * transitions together.
 */
function getLocalBounds(element) {
  var cloneElement = element.cloneNode();
  var animations = element.getAnimations();
  cloneElement.style.visibility = 'hidden';
  animations.forEach(function (animation) {
    var keyframes = animation.effect.getKeyframes();
    cloneElement.attr(keyframes[keyframes.length - 1]);
  });
  element.parentNode.appendChild(cloneElement);
  var bounds = cloneElement.getLocalBounds();
  cloneElement.destroy();
  var min = bounds.min,
    max = bounds.max;
  return [min, max];
}
function createLabelShapeFunction(mark, state, view, library, context) {
  var _useLibrary21 = useLibrary('shape', library),
    _useLibrary22 = _slicedToArray(_useLibrary21, 1),
    useShape = _useLibrary22[0];
  var abstractData = mark.data;
  var visualData = state.data,
    defaultLabelShape = state.defaultLabelShape;
  var point2d = visualData.map(function (d) {
    return d.points;
  });
  // Assemble Context.
  var theme = view.theme,
    coordinate = view.coordinate;
  var shapeContext = Object.assign(Object.assign({}, context), {
    document: documentOf(context),
    theme: theme,
    coordinate: coordinate
  });
  return function (options) {
    // Computed values from data and styles.
    var index = options.index,
      points = options.points;
    var datum = abstractData[index];
    var _options$formatter = options.formatter,
      formatter = _options$formatter === void 0 ? function (d) {
        return "".concat(d);
      } : _options$formatter,
      transform = options.transform,
      abstractStyle = options.style,
      render = options.render,
      abstractOptions = __rest(options, ["formatter", "transform", "style", "render"]);
    var visualOptions = mapObject(Object.assign(Object.assign({}, abstractOptions), abstractStyle), function (d) {
      return valueOf(d, datum, index, abstractData);
    });
    var _visualOptions$shape = visualOptions.shape,
      shape = _visualOptions$shape === void 0 ? defaultLabelShape : _visualOptions$shape,
      text = visualOptions.text,
      style = __rest(visualOptions, ["shape", "text"]);
    var f = typeof formatter === 'string' ? format(formatter) : formatter;
    var value = Object.assign(Object.assign({}, style), {
      text: f(text, datum, index, abstractData),
      datum: datum
    });
    // Params for create shape.
    var shapeOptions = Object.assign({
      type: "label.".concat(shape),
      render: render
    }, style);
    var shapeFunction = useShape(shapeOptions, shapeContext);
    var defaults = getDefaultsStyle(theme, 'label', shape, 'label');
    return shapeFunction(points, value, defaults, point2d);
  };
}
function valueOf(value, datum, i, data) {
  if (typeof value === 'function') return value(datum, i, data);
  if (typeof value !== 'string') return value;
  if (datum[value] !== undefined) return datum[value];
  return value;
}
/**
 * Compute max duration for this frame.
 */
function computeAnimationExtent(markState) {
  var maxDuration = -Infinity;
  var minDelay = Infinity;
  var _iterator16 = _createForOfIteratorHelper(markState),
    _step16;
  try {
    for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
      var _step16$value = _slicedToArray(_step16.value, 2),
        mark = _step16$value[0],
        state = _step16$value[1];
      var _mark$animate = mark.animate,
        animate = _mark$animate === void 0 ? {} : _mark$animate;
      var data = state.data;
      var _animate$enter = animate.enter,
        enter = _animate$enter === void 0 ? {} : _animate$enter,
        _animate$update = animate.update,
        update = _animate$update === void 0 ? {} : _animate$update,
        _animate$exit = animate.exit,
        exit = _animate$exit === void 0 ? {} : _animate$exit;
      var defaultUpdateType = update.type,
        _update$duration = update.duration,
        defaultUpdateDuration = _update$duration === void 0 ? 300 : _update$duration,
        _update$delay = update.delay,
        defaultUpdateDelay = _update$delay === void 0 ? 0 : _update$delay;
      var defaultEnterType = enter.type,
        _enter$duration = enter.duration,
        defaultEnterDuration = _enter$duration === void 0 ? 300 : _enter$duration,
        _enter$delay = enter.delay,
        defaultEnterDelay = _enter$delay === void 0 ? 0 : _enter$delay;
      var defaultExitType = exit.type,
        _exit$duration = exit.duration,
        defaultExitDuration = _exit$duration === void 0 ? 300 : _exit$duration,
        _exit$delay = exit.delay,
        defaultExitDelay = _exit$delay === void 0 ? 0 : _exit$delay;
      var _iterator17 = _createForOfIteratorHelper(data),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var d = _step17.value;
          var _d$updateType = d.updateType,
            updateType = _d$updateType === void 0 ? defaultUpdateType : _d$updateType,
            _d$updateDuration = d.updateDuration,
            updateDuration = _d$updateDuration === void 0 ? defaultUpdateDuration : _d$updateDuration,
            _d$updateDelay = d.updateDelay,
            updateDelay = _d$updateDelay === void 0 ? defaultUpdateDelay : _d$updateDelay,
            _d$enterType = d.enterType,
            enterType = _d$enterType === void 0 ? defaultEnterType : _d$enterType,
            _d$enterDuration = d.enterDuration,
            enterDuration = _d$enterDuration === void 0 ? defaultEnterDuration : _d$enterDuration,
            _d$enterDelay = d.enterDelay,
            enterDelay = _d$enterDelay === void 0 ? defaultEnterDelay : _d$enterDelay,
            _d$exitDuration = d.exitDuration,
            exitDuration = _d$exitDuration === void 0 ? defaultExitDuration : _d$exitDuration,
            _d$exitDelay = d.exitDelay,
            exitDelay = _d$exitDelay === void 0 ? defaultExitDelay : _d$exitDelay,
            _d$exitType = d.exitType,
            exitType = _d$exitType === void 0 ? defaultExitType : _d$exitType;
          if (updateType === undefined || updateType) {
            maxDuration = Math.max(maxDuration, updateDuration + updateDelay);
            minDelay = Math.min(minDelay, updateDelay);
          }
          if (exitType === undefined || exitType) {
            maxDuration = Math.max(maxDuration, exitDuration + exitDelay);
            minDelay = Math.min(minDelay, exitDelay);
          }
          if (enterType === undefined || enterType) {
            maxDuration = Math.max(maxDuration, enterDuration + enterDelay);
            minDelay = Math.min(minDelay, enterDelay);
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  } catch (err) {
    _iterator16.e(err);
  } finally {
    _iterator16.f();
  }
  if (maxDuration === -Infinity) return null;
  return [minDelay, maxDuration - minDelay];
}
function selectFacetElements(selection, current, facetClassName, elementClassName) {
  var group = selection.node().parentElement;
  return group.findAll(function (node) {
    return node.style.facet !== undefined && node.style.facet === facetClassName && node !== current.node();
  }).flatMap(function (node) {
    return node.getElementsByClassName(elementClassName);
  });
}
/**
 * Update the parent of element and apply transform to make it
 * stay in original position.
 */
function maybeFacetElement(element, parent, originOf) {
  if (!element.__facet__) return;
  // element -> g#main -> rect#plot
  var prePlot = element.parentNode.parentNode;
  // g#main -> rect#plot
  var newPlot = parent.parentNode;
  var _originOf = originOf(prePlot),
    _originOf2 = _slicedToArray(_originOf, 2),
    px = _originOf2[0],
    py = _originOf2[1];
  var _originOf3 = originOf(newPlot),
    _originOf4 = _slicedToArray(_originOf3, 2),
    x = _originOf4[0],
    y = _originOf4[1];
  var translate = "translate(".concat(px - x, ", ").concat(py - y, ")");
  appendTransform(element, translate);
  parent.append(element);
}
function createMarkShapeFunction(mark, state, view, library, context) {
  var _useLibrary23 = useLibrary('shape', library),
    _useLibrary24 = _slicedToArray(_useLibrary23, 1),
    useShape = _useLibrary24[0];
  var abstractData = mark.data;
  var defaultShape = state.defaultShape,
    data = state.data,
    shapeLibrary = state.shape;
  var point2d = data.map(function (d) {
    return d.points;
  });
  var theme = view.theme,
    coordinate = view.coordinate;
  var markType = mark.type,
    _mark$style = mark.style,
    style = _mark$style === void 0 ? {} : _mark$style;
  var shapeContext = Object.assign(Object.assign({}, context), {
    document: documentOf(context),
    coordinate: coordinate,
    theme: theme
  });
  return function (data) {
    var _style$shape = style.shape,
      styleShape = _style$shape === void 0 ? defaultShape : _style$shape;
    var _data$shape = data.shape,
      shape = _data$shape === void 0 ? styleShape : _data$shape,
      points = data.points,
      seriesIndex = data.seriesIndex,
      i = data.index,
      v = __rest(data, ["shape", "points", "seriesIndex", "index"]);
    var value = Object.assign(Object.assign({}, v), {
      index: i
    });
    // Get data-driven style.
    // If it is a series shape, such as area and line,
    // provides the series of abstract data and indices
    // for this shape, otherwise the single datum and
    // index.
    var abstractDatum = seriesIndex ? seriesIndex.map(function (i) {
      return abstractData[i];
    }) : abstractData[i];
    var I = seriesIndex ? seriesIndex : i;
    var visualStyle = mapObject(style, function (d) {
      return valueOf(d, abstractDatum, I, abstractData);
    });
    // Try get shape from mark first, then from library.
    var shapeFunction = shapeLibrary[shape] ? shapeLibrary[shape](visualStyle, shapeContext) : useShape(Object.assign(Object.assign({}, visualStyle), {
      type: shapeName(mark, shape)
    }), shapeContext);
    var defaults = getDefaultsStyle(theme, markType, shape, defaultShape);
    return shapeFunction(points, value, defaults, point2d);
  };
}
function getDefaultsStyle(theme, mark, shape, defaultShape) {
  if (typeof mark !== 'string') return;
  var color = theme.color;
  var markTheme = theme[mark] || {};
  var shapeTheme = markTheme[shape] || markTheme[defaultShape];
  return Object.assign({
    color: color
  }, shapeTheme);
}
function createAnimationFunction(type, mark, state, view, library) {
  var _a, _b;
  var _useLibrary25 = useLibrary('shape', library),
    _useLibrary26 = _slicedToArray(_useLibrary25, 2),
    createShape = _useLibrary26[1];
  var _useLibrary27 = useLibrary('animation', library),
    _useLibrary28 = _slicedToArray(_useLibrary27, 1),
    useAnimation = _useLibrary28[0];
  var defaultShape = state.defaultShape,
    shapeLibrary = state.shape;
  var theme = view.theme,
    coordinate = view.coordinate;
  var upperType = upperFirst(type);
  var key = "default".concat(upperType, "Animation");
  // Get shape from mark first, then from library.
  var _ref18 = ((_a = shapeLibrary[defaultShape]) === null || _a === void 0 ? void 0 : _a.props) || createShape(shapeName(mark, defaultShape)).props,
    defaultAnimation = _ref18[key];
  var _theme$type = theme[type],
    defaultEffectTiming = _theme$type === void 0 ? {} : _theme$type;
  var animate = ((_b = mark.animate) === null || _b === void 0 ? void 0 : _b[type]) || {};
  var context = {
    coordinate: coordinate
  };
  return function (data, from, to) {
    var animation = data["".concat(type, "Type")],
      delay = data["".concat(type, "Delay")],
      duration = data["".concat(type, "Duration")],
      easing = data["".concat(type, "Easing")];
    var options = Object.assign({
      type: animation || defaultAnimation
    }, animate);
    if (!options.type) return null;
    var animateFunction = useAnimation(options, context);
    var value = {
      delay: delay,
      duration: duration,
      easing: easing
    };
    var A = animateFunction(from, to, deepMix(defaultEffectTiming, value));
    if (!Array.isArray(A)) return [A];
    return A;
  };
}
function createEnterFunction(mark, state, view, library) {
  return createAnimationFunction('enter', mark, state, view, library);
}
/**
 * Animation will not cancel automatically, it should be canceled
 * manually. This is very important for performance.
 */
function cancel(animation) {
  animation.finished.then(function () {
    animation.cancel();
  });
  return animation;
}
function createUpdateFunction(mark, state, view, library) {
  return createAnimationFunction('update', mark, state, view, library);
}
function createExitFunction(mark, state, view, library) {
  return createAnimationFunction('exit', mark, state, view, library);
}
function inferTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (typeof theme === 'string') return {
    type: theme
  };
  var _theme$type2 = theme.type,
    type = _theme$type2 === void 0 ? 'light' : _theme$type2,
    rest = __rest(theme, ["type"]);
  return Object.assign(Object.assign({}, rest), {
    type: type
  });
}
/**
 * @todo Infer builtin tooltips.
 */
function inferInteraction(view) {
  var defaults = {
    event: true,
    tooltip: true,
    // @todo Inferred by slider self.
    sliderFilter: true,
    legendFilter: true,
    scrollbarFilter: true
  };
  var _view$interaction = view.interaction,
    interaction = _view$interaction === void 0 ? {} : _view$interaction;
  return Object.entries(deepMix(defaults, interaction));
}
function applyTransform(node, library) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var context, data, rest, _yield$applyDataTrans, _yield$applyDataTrans2, newData;
    return _regeneratorRuntime().wrap(function _callee9$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          context = {
            library: library
          };
          data = node.data, rest = __rest(node, ["data"]);
          if (!(data == undefined)) {
            _context13.next = 4;
            break;
          }
          return _context13.abrupt("return", node);
        case 4:
          _context13.next = 6;
          return applyDataTransform([], {
            data: data
          }, context);
        case 6:
          _yield$applyDataTrans = _context13.sent;
          _yield$applyDataTrans2 = _slicedToArray(_yield$applyDataTrans, 2);
          newData = _yield$applyDataTrans2[1].data;
          return _context13.abrupt("return", Object.assign({
            data: newData
          }, rest));
        case 10:
        case "end":
          return _context13.stop();
      }
    }, _callee9);
  }));
}
function updateBBox(selection) {
  selection.style('x', function (d) {
    return d.paddingLeft + d.marginLeft;
  }).style('y', function (d) {
    return d.paddingTop + d.marginTop;
  }).style('width', function (d) {
    return d.innerWidth;
  }).style('height', function (d) {
    return d.innerHeight;
  });
}
function animateBBox(selection, extent) {
  var _extent = _slicedToArray(extent, 2),
    delay = _extent[0],
    duration = _extent[1];
  selection.transition(function (data, i, element) {
    var _element$style = element.style,
      x = _element$style.x,
      y = _element$style.y,
      width = _element$style.width,
      height = _element$style.height;
    var paddingLeft = data.paddingLeft,
      paddingTop = data.paddingTop,
      innerWidth = data.innerWidth,
      innerHeight = data.innerHeight,
      marginLeft = data.marginLeft,
      marginTop = data.marginTop;
    var keyframes = [{
      x: x,
      y: y,
      width: width,
      height: height
    }, {
      x: paddingLeft + marginLeft,
      y: paddingTop + marginTop,
      width: innerWidth,
      height: innerHeight
    }];
    return element.animate(keyframes, {
      delay: delay,
      duration: duration,
      fill: 'both'
    });
  });
}
function shapeName(mark, name) {
  var type = mark.type;
  if (typeof name === 'string') return "".concat(type, ".").concat(name);
  return name;
}
/**
 * Create and update layer for each mark.
 * All the layers created here are treated as main layers.
 */
function updateLayers(selection, marks) {
  var facet = function facet(d) {
    return d.class !== undefined ? "".concat(d.class) : '';
  };
  // Skip for empty selection, it can't append nodes.
  var nodes = selection.nodes();
  if (nodes.length === 0) return;
  selection.selectAll(className(MAIN_LAYER_CLASS_NAME)).data(marks, function (d) {
    return d.key;
  }).join(function (enter) {
    return enter.append('g').attr('className', MAIN_LAYER_CLASS_NAME).attr('id', function (d) {
      return d.key;
    }).style('facet', facet).style('fill', 'transparent').style('zIndex', function (d) {
      var _a;
      return (_a = d.zIndex) !== null && _a !== void 0 ? _a : 0;
    });
  }, function (update) {
    return update.style('facet', facet).style('fill', 'transparent').style('zIndex', function (d) {
      var _a;
      return (_a = d.zIndex) !== null && _a !== void 0 ? _a : 0;
    });
  }, function (exit) {
    return exit.remove();
  });
  var labelLayer = selection.select(className(LABEL_LAYER_CLASS_NAME)).node();
  if (labelLayer) return;
  selection.append('g').attr('className', LABEL_LAYER_CLASS_NAME).style('zIndex', 0);
}
function className() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }
  return names.map(function (d) {
    return ".".concat(d);
  }).join('');
}
function applyClip(selection, clip) {
  if (!selection.node()) return;
  selection.style('clipPath', function (data) {
    if (!clip) return null;
    var y = data.paddingTop,
      x = data.paddingLeft,
      x1 = data.marginLeft,
      y1 = data.marginTop,
      width = data.innerWidth,
      height = data.innerHeight;
    return new Rect({
      style: {
        x: x + x1,
        y: y + y1,
        width: width,
        height: height
      }
    });
  });
}
function inferComponentScales(scales, states, markState) {
  // add shape scale to state.
  var _a;
  // for cell, omit shape scale.
  // @todo support shape scale for cell.
  var _iterator18 = _createForOfIteratorHelper(markState.entries()),
    _step18;
  try {
    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
      var _step18$value = _slicedToArray(_step18.value, 1),
        key = _step18$value[0];
      if (key.type === 'cell') {
        return scales.filter(function (scale) {
          return scale.name !== 'shape';
        });
      }
    }
    // can't infer shape scale if there are multiple states.
  } catch (err) {
    _iterator18.e(err);
  } finally {
    _iterator18.f();
  }
  if (states.length !== 1 || scales.some(function (scale) {
    return scale.name === 'shape';
  })) {
    return scales;
  }
  var shape = states[0].defaultShape;
  var acceptMarkTypes = ['point', 'line', 'rect', 'hollow'];
  if (!acceptMarkTypes.includes(shape)) return scales;
  var shapeMap = {
    point: 'point',
    line: 'hyphen',
    rect: 'square',
    hollow: 'hollow'
  };
  // create shape scale
  var field = ((_a = scales.find(function (scale) {
    return scale.name === 'color';
  })) === null || _a === void 0 ? void 0 : _a.field) || null;
  var shapeScale = {
    field: field,
    name: 'shape',
    type: 'constant',
    domain: [],
    range: [shapeMap[shape]]
  };
  return [].concat(_toConsumableArray(scales), [shapeScale]);
}
export function applyStyle(selection, style) {
  for (var _i3 = 0, _Object$entries2 = Object.entries(style); _i3 < _Object$entries2.length; _i3++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    selection.style(key, value);
  }
}